import type { JSONDocNode } from '@atlaskit/editor-json-transformer/types';

export const hasHardBreakInADF = (adf: JSONDocNode): boolean => {
	// Check if the first paragraph has content with hardBreak type
	const firstParagraph = adf.content?.[0];
	if (firstParagraph?.type === 'paragraph' && firstParagraph.content) {
		return firstParagraph.content.some((item) => item?.type === 'hardBreak');
	}
	return false;
};
